
export const playerLogFields = [
    {
        key: "log",
        tdClass: "text-left",
        label: ""
    }
];
